import request from '@/utils/request'

// 获取新增数据统计接口
export function getNewdata(query) {
    return request({
      url: '/system/index/new-data',
      method: 'get',
      params: query
    })
}

// 获取用户活跃统计接口
export function getNewMemberdata(query) {
    return request({
      url: '/system/index/act-member',
      method: 'get',
      params: query
    })
}

// 获取询单统计接口
export function getNewOrderdata(query) {
    return request({
      url: '/system/index/act-order',
      method: 'get',
      params: query
    })
}

// 获取订购登记统计接口
export function getNewRegisterdata(query) {
    return request({
      url: '/system/index/act-register',
      method: 'get',
      params: query
    })
}

// 获取申样统计接口
export function getNewSampledata(query) {
    return request({
      url: '/system/index/act-sample',
      method: 'get',
      params: query
    })
}

  

 // 获得消息分页
 export function getStationMessagePage() {
    return request({
      url: '/system/index/msg',
      method: 'get'
    })
  }

  export function getStationMessagePageData(query) {
    return request({
      url: '/system/msg/page',
      method: 'get',
      params: query
    })
  }

  export function getBackGet(query) {
    return request({
        url: '/system/msg/get-all-num',
        method: 'get',
        params: query
    })
}